import deviceInfoBase from './deviceInfoBase';

const deviceInfo = deviceInfoBase();
export default deviceInfo;